import React, { useContext } from "react";

import PermissionWrapper from "../../../../../../../global/PermissionWrapper";
import { StaticBarStateContext } from "../../context/StaticBarContext";
import DateOfAccident from "../fields/DateOfAccident/DateOfAccident";
import IncidentType from "../fields/IncidentType";
import Location from "../fields/Location/Location";
import PDSeverity from "../fields/PDSeverity";
import Column from "../ui/Column";

const CaseSummary = () => {
  const state = useContext(StaticBarStateContext);
  return (
    <Column>
      {state.data?.dateOfAccident && state.data?.statuteOfLimitations && (
        <PermissionWrapper
          permission={
            state.data?.dateOfAccident?.can_view && state.data?.statuteOfLimitations?.can_view
          }
        >
          <DateOfAccident
            fieldName={state.data?.statuteOfLimitations?.fieldName}
            date={state.data?.dateOfAccident?.value}
            statuteOfLimitations={state.data?.statuteOfLimitations?.value}
            flag={state.data?.statuteOfLimitations?.flag_state}
            clock={state.data?.statuteOfLimitations?.clock_state}
          />
        </PermissionWrapper>
      )}
      {state.data?.incidentType && (
        <PermissionWrapper permission={state.data?.incidentType?.can_view}>
          <IncidentType
            fieldName={state.data?.incidentType?.fieldName}
            value={state.data?.incidentType?.value}
            flag={state.data?.incidentType?.flag_state}
            clock={state.data?.incidentType?.clock_state}
          />
        </PermissionWrapper>
      )}
      {state.data?.incidentCity && (
        <PermissionWrapper permission={state.data?.incidentCity?.can_view}>
          <Location
            fieldName={state.data?.incidentCity?.fieldName}
            incidentCity={state.data?.incidentCity?.value}
            incidentState={state.data?.incidentState?.value}
            flag={state.data?.incidentState?.flag_state}
            clock={state.data?.incidentState?.clock_state}
          />
        </PermissionWrapper>
      )}
      {state.data?.propertyDamageSeverity && (
        <PermissionWrapper permission={state.data?.propertyDamageSeverity?.can_view}>
          <PDSeverity
            fieldName={state.data?.propertyDamageSeverity?.fieldName}
            value={state.data?.propertyDamageSeverity?.value}
            flag={state.data?.propertyDamageSeverity?.flag_state}
            clock={state.data?.propertyDamageSeverity?.clock_state}
          />
        </PermissionWrapper>
      )}
    </Column>
  );
};

export default CaseSummary;
